"use strict";

var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_inputrules_1 = require("prosemirror-inputrules");

var Node_1 = __importDefault(require("./Node"));

var toggleWrap_1 = __importDefault(require("../commands/toggleWrap"));

var Blockquote = /*#__PURE__*/function (_Node_1$default) {
  _inherits(Blockquote, _Node_1$default);

  var _super = _createSuper(Blockquote);

  function Blockquote() {
    _classCallCheck(this, Blockquote);

    return _super.apply(this, arguments);
  }

  _createClass(Blockquote, [{
    key: "inputRules",
    value: function inputRules(_ref) {
      var type = _ref.type;
      return [prosemirror_inputrules_1.wrappingInputRule(/^\s*>\s$/, type)];
    }
  }, {
    key: "commands",
    value: function commands(_ref2) {
      var type = _ref2.type;
      return function () {
        return toggleWrap_1.default(type);
      };
    }
  }, {
    key: "keys",
    value: function keys(_ref3) {
      var type = _ref3.type;
      return {
        "Ctrl->": toggleWrap_1.default(type),
        "Mod-]": toggleWrap_1.default(type)
      };
    }
  }, {
    key: "toMarkdown",
    value: function toMarkdown(state, node) {
      state.wrapBlock("> ", null, node, function () {
        return state.renderContent(node);
      });
    }
  }, {
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return {
        block: "blockquote"
      };
    }
  }, {
    key: "name",
    get: function get() {
      return "blockquote";
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        content: "block+",
        group: "block",
        defining: true,
        parseDOM: [{
          tag: "blockquote"
        }],
        toDOM: function toDOM() {
          return ["blockquote", 0];
        }
      };
    }
  }]);

  return Blockquote;
}(Node_1.default);

exports.default = Blockquote;